import React, { useState } from 'react'
import { Col, Form, Row, Button, Card } from 'react-bootstrap'
import CallScreen from '../components/CallScreen'
import LeadTable from '../components/Table'
import MeetingTable from '../components/Table'
import Format from '../utils/format-text'
import EventEmitter from '../utils/EventEmitter'
import { useEffect } from 'react'
import moment from 'moment'
import {
  fetch_meetings,
  editMeeting,
  create_meeting,
} from '../redux/actions/Meetings'
import { useDispatch, useSelector } from 'react-redux'
import Dialogbox from '../components/Dialogbox'
import Filters from '../components/filter'
import { useNavigate } from 'react-router'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Outbound } from '../redux/SocketAction/SocketAction'
import { callmodule } from '../redux/Calls/CallAction'
import { Encode } from '../utils/EncodeDecode'
import { ContactFetch } from '../redux/actions/ContactActions'
import { CustomformData } from '../redux/actions/Customform'
import waicon from '../assets/images/whatsapp.svg'
import { getTemplate } from '../redux/actions/ChatActions'
import { waTemplate } from '../redux/SocketAction/SocketAction'
function Meeting() {

  const user_id = localStorage.getItem('user')
  let AppPermission
  let campaigninfo = JSON.parse(localStorage.getItem('selectedCampaign_data'))
  let [wadata, setwadata] = useState([])
  const [popupdata, setpopupdata] = useState({
    open: false,
    Type: 'form_bar',
    field: [
      {
        type: 'TextInput',
        label: 'Meeting Name',
        placeholder: 'enter Meeting Name',
        required: true,
        model: 'name',
        value: "",
        readonly: false,
        multiple: false,
        fieldtype: 'others',
        model_type: "Text"
      }
      ,
      {
        type: 'TextInput',
        label: 'Phone Number',
        placeholder: 'Phone Number',
        required: true,
        model: 'meetingphoneNumber',
        value: "",
        readonly: false,
        multiple: false,
        fieldtype: 'phone_number',
        model_type: "Number"
      }, {
        type: 'SelectList',
        label: 'Module',
        placeholder: 'Module',
        required: true,
        model: 'module',
        option: [],
        multiple: false,
        value: '',
      },
      {
        type: 'DatetimePicker',
        label: 'Schedule Date',
        placeholder: 'please select',
        required: true,
        model: 'scheduleDate',
        multiple: true,
        value: moment(datetime()).add(35, 'm').toDate(),
      },
      {
        type: 'LongTextInput',
        label: 'Discription',
        placeholder: 'enter your comments',
        required: true,
        model: 'comments',
        value: '',
        multiple: false,
      },
    ],

    title: 'Create Meeting',
    Message: 'Created Successfully ',
    Butonstatus: 'Create',
  })
  const [popUpData_, setpopUpData_] = useState({
    open: false,
    Type: 'form_bar',
    field: [
      {
        type: 'SelectList',
        label: 'Whatsapp Template',
        placeholder: ' select message',
        required: true,
        model: 'whatsapp_template',
        option: [],
        multiple: false,
        value: '',
      },
    ],
    title: 'Whatsapp Template',
    Message: 'Selected Successfully',
    Butonstatus: 'Send',
  })
  let wasession = localStorage.getItem("wasession")
  if (localStorage.getItem('config')) {
    AppPermission = JSON.parse(localStorage.getItem('config')).data.projects[0].userPermission
  }
  let [maskphoneindex, setmaskphoneindex] = useState({ index: 0, value: "" })
  let stateValue = useSelector((state) => state)
  const [lead_id, setLead_id] = useState('')
  const [shedulealart, setshedulealart] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState('')
  const [searchdata, setSearch] = useState('')
  let dispatch = useDispatch()
  const [meetingDetail, setMeetingDetail] = useState([])
  const [editId, setEditId] = useState('')
  const [skipdata, setskipdata] = useState({ skip: 0, take: 20 })
  const [count, setcount] = useState(0)
  const [infinitScroll, setinfinitScroll] = useState({ limit: 7, more: true })
  const [filterdata, setfilterdata] = useState({})
  let selected_campaign = localStorage.getItem('selectedCampaign')
  let navigate = useNavigate()
  const [popUpData, setpopUpData] = useState({
    open: false,
    Type: 'form_bar',
    field: [
      {
        type: 'DatetimePicker',
        label: 'Schedule Date ',
        placeholder: 'please select',
        required: true,
        model: 'schedule_date',
        multiple: true,
        value: '',
      },
    ],
    title: 'Update Schedule Date (Schedule Date Must 30Min After)',
    Message: 'Updated Successfully',
    Butonstatus: 'Save',
  })

  const [popUpDatatoCreate, setPopUpDatatoCreate] = useState({
    open: false,
    Type: 'form_bar',
    field: [
      {
        type: 'TextInput',
        label: 'Phone Number',
        placeholder: 'enter your phoneNumber',
        required: true,
        model: 'phoneNumber',
        value: phoneNumber != '' ? phoneNumber : '',
        multiple: false,
      },
      {
        type: 'DatetimePicker',
        label: 'Schedule Date ',
        placeholder: 'please select',
        required: true,
        model: 'scheduleDate',
        multiple: false,
        value: datetime(),
      },
      {
        type: 'LongTextInput',
        label: 'Comments',
        placeholder: 'enter your comments',
        required: true,
        model: 'comments',
        value: '',
        multiple: false,
      },
    ],
    title: 'Create Meeting (Schedule Date Must 30Min After)',
    Message: 'Created Successfully',
    Butonstatus: 'Create',
  })

  const [popUpData1, setpopUpData1] = useState({
    open: false,
    Type: 'Notification_bar',
    field: [],
    title: 'Update Schedule Date',
    Message: 'Sheduled date updated Successfully',
    Butonstatus: 'OK',
  })



  const [header, setheader] = useState([
    {
      Header: 'Meeting Id',
      accessor: 'meeting_id',

    },

    {
      Header: 'Phone Number',
      accessor: 'leadNumber',
    },
    {
      Header: 'Campaign',
      accessor: 'leadCampaign',
    },
    {
      Header: 'Schedule Date',
      accessor: 'schedule_date',
    },
    {
      Header: 'Status',
      accessor: 'leadStatus',
    },

    {
      Header: 'Action',
      accessor: 'row_id',
      Cell: ({ row }) => {
        return (
          <div className="lead_action">
            {AppPermission.meeting_reschedule && <div
              className="material-icons"
              onClick={() =>
                dialogopen(
                  true,
                  row.original.row_id,
                  row.original.schedule_date,
                )
              }
              style={{ color: '#FF9900' }}
            >
              history
            </div>
            }
            {AppPermission.view_meeting && <span
              onClick={() =>
                MeetingView(row, 'MeetingView', row.original.row_id)
              }
              className="material-icons"
              style={{ color: '#3e98c7' }}
            >
              info
            </span>}
            {AppPermission.view_meeting && <span
              onClick={() =>
                clickcall(row)
              }
              className={stateValue.background.oncall == false && wasession === "false" ? "material-icons" : "material-icons disabledbutton"}
              style={{ color: '#32AA52' }}
            >
              phone
            </span>}
            {AppPermission.wa_view &&
              <img
                onClick={() => { wapopup(row.original) }}
                className={"wa_icon"}
                src={waicon}
                alt="test"
              />


            }

          </div>
        )
      },
    },
  ])
  useEffect(() => {
    if (stateValue.background.oncall) {
      setLead_id(stateValue.background.oncalllead[0].lead_id)
      setPhoneNumber(stateValue.background.oncalllead[0].phone_number)
    }
    fetchMeetings()
    let index = header.findIndex((elm => elm.Header == "Phone Number"))
    if (index != -1) {
      setmaskphoneindex({ index: index, value: header[index].accessor })
    }
    dispatch(getTemplate()).then((res) => {
      if (res.data.length > 0) {

        setpopUpData_((set) => {
          set.field[0].option = res.data
          return {
            ...set
          }
        })
      }
    }).catch((err) => {
      EventEmitter.emit('error-message-getter', {
        action: 'fetch',
        module: "whatsapp Template",
      })
    })
  }, [])

  function datetime() {
    var currentdate = new Date().toISOString()
    return currentdate
  }
  function closepopup_(data) {
    if (data.action === "cancel") {
      setpopUpData_((set) => {
        set.open = false
        return {
          ...set
        }
      })
    } else {


      let name

      dispatch(
        ContactFetch(
          `/contact/fetchsearch?number=${Number(wadata.leadNumber)}`,
        ),
      )
        .then((res) => {
          if (res.data.statusCode == 200 && res.data.data.length > 0) {
            name = res.data.data[0].name
            sendtemp(data, name, 'contact', res.data.data[0].id)
          }
          else {
            let payload = {
              template_name: campaigninfo.template_name,
              type: campaigninfo.type,
              phone_number: wadata.leadNumber,
              id: ""
            }
            dispatch(CustomformData(payload)).then((res) => {
              if (res.data.statusCode == 200) {
                name = res.data.data[0].others.first_name
                sendtemp(data, name, '_', res.data.data[0].others.lead_id)
              }
            }).catch((err) => {
              EventEmitter.emit('error-message-getter', {
                action: 'fetch',
                module: 'lead data',
              })
            })
          }
        }).catch(() => {
          EventEmitter.emit('error-message-getter', {
            action: 'fetch',
            module: "contact",
          })
        })

    }


  }
  function wapopup(data) {
    setwadata(data)
    setpopUpData_((set) => {
      set.open = true
      return {
        ...set
      }
    })
  }
  function datetime() {
    var currentdate = new Date()
    return currentdate
  }
  function sendtemp(data, name, module, id) {
    function find_(data_) {

      return data_.value === data.data[0].whatsapp_template;
    }
    let templatedata = {
      "action": "send-wa-template",
      "station": localStorage.getItem('extension'),
      "phone_number": wadata.leadNumber,
      "sender_id": id,
      "sender_type": module === "contact" ? 1 : 2,
      "sender_name": name,
      "tenant_id": JSON.parse(localStorage.getItem("config")).data.tenant_code,
      "agent": localStorage.getItem("user"),
      "template": {
        "id": data.data[0].whatsapp_template.split(",_,")[0],
        "type": "",
        "name": data.data[0].whatsapp_template.split(",_,")[1],
        "language": data.field[0].option.find(find_).data.language
      }
    }
    if (data.action === "create") {
      dispatch(waTemplate(stateValue.background.websocketconnection, templatedata))
      setpopUpData_((set) => {
        set.open = false
        return {
          ...set
        }
      })
    }



  }
  const dialogopen = (data, id, date) => {
    if (id) setEditId(id)
    setpopUpData((set) => {
      set.open = data
      set.field[0].value = date
      return {
        ...set,
      }
    })
  }
  const dialogOpenToCreate = (data) => {
    setPopUpDatatoCreate((set) => {
      set.open = data
      return {
        ...set,
      }
    })
  }
  const notify_bar = (data, action) => {
    setpopUpData1((set) => {
      set.open = data
      if (action == 'update') {
        set.Message = 'Update Sucessfully'
      } else {
        set.Message = 'Created Sucessfully'
        set.title = "Meeting Create "
      }
      return {
        ...set,
      }
    })
  }
  const closepopup = (data) => {
    // let schedule_date = { scheduleDate: data.data[0].schedule_date, sms_notify:"0", wa_notify:"0", email_notify:"0",api_push:"0" }
    let schedule_date = { scheduleDate: data.data[0].schedule_date}
    if (data.action === 'create') {
      dispatch(editMeeting(editId, schedule_date)).then(function (res) {
        if (res.data.statusCode == 200) {
          notify_bar(true, 'update')
          fetchMeetings("refresh")
          setpopUpData((data) => {
            data.open = false
            return {
              ...data,
            }
          })
        }
        if (res.status == 204) {
          setshedulealart(true)

        }
      }).catch((err) => {
        EventEmitter.emit('error-message-getter', {
          action: 'update',
          module: 'meeting',
        })
      })


    } else {
      setpopUpData((data) => {
        data.open = false
        return {
          ...data,
        }
      })
    }
  }
  const close_meetingpopup = (data) => {
    if (data.action === "create") {
      let payload = {
        meetingName: data.data[0]['name'],
        meetingTilte: data.data[0]['comments'],
        meetingTime: data.data[0]['scheduleDate'],
        user_email: localStorage.getItem('user'),
        leadID: data.data[0]['id'].toString(),
        phoneNumber: data.data[0]['meetingphoneNumber'],
        campaign: selected_campaign,
        module: data.data[0]['module'],
        callerName: data.data[0]['meetingphoneNumber'],
      }
      dispatch(create_meeting(payload))
        .then(function (res) {
          if (res.data.statusCode == 201) {
            fetchMeetings("refresh")
            setpopupdata((data) => {
              data.open = false
              return {
                ...data,
              }
            })
          }

        })
        .catch((err) => {

          EventEmitter.emit('error-message-getter', {
            action: 'create',
            module: 'meeting',
          })
        })
    } else {
      setpopupdata((data) => {
        data.open = false
        return {
          ...data,
        }
      })
    }

  }
  const closeCreatePopup = (data) => {
    if (data.action === 'create') {

      let selected_user = localStorage.getItem('user')
      let payload = {
        meetingTilte: data.data[0]['comments'],
        meetingTime: data.data[0]['scheduleDate'],
        user_email: selected_user,
        leadID: data.data[0]['phoneNumber'] === phoneNumber ? `${lead_id}` : "",
        phoneNumber: data.data[0]['phoneNumber'],
        campaign: selected_campaign,
      }

      dispatch(create_meeting(payload)).then(function (res) {
        if (res.data.statusCode == 201) {
          notify_bar(true, 'create')
          fetchMeetings("refresh")
        }
      }).catch((err) => {
        EventEmitter.emit('error-message-getter', {
          action: 'create',
          module: 'meeting',
        })
      })
      setPopUpDatatoCreate((data) => {
        data.open = false
        return {
          ...data,
        }
      })
    } else {
      setPopUpDatatoCreate((data) => {
        data.open = false
        return {
          ...data,
        }
      })
    }
  }
  const closeNotify = (data) => {
    setpopUpData1(data)
  }

  const MeetingView = (row, pageName, id) => {
    if (pageName === 'MeetingView') {
      navigate(`/meeting/${Encode(row.original.leadNumber)}/${id}`)
    }
  }
  const fetchMeetings = (search) => {
    const user_id = localStorage.getItem('user')
    let query = {
      userID: user_id,
    }
    query.skip = skipdata.skip
    query.take = skipdata.take
    if (search !== 'mount' && search !== 'filter' && search !== 'refresh') {
      query.filter = search
    }
    if (search == 'filter') {
      query.fromDate = filterdata.from
      query.toDate = filterdata.to
      query.module = filterdata.module
    }
    if (search == "refresh") {
      query.skip = 0
      query.take = 20
      setfilterdata({})
      setSearch("")
      setinfinitScroll((set) => {
        set.more = true
        return {
          ...set,
        }
      })
    }
    dispatch(fetch_meetings(query)).then(function (response) {
      let element = response.data.data
      let value = []

      if (response.status == 200) {
        setcount(response.data.totalCount)
        setskipdata((set) => {
          if (search !== "refresh") {
            if (set.take === 20) {
              set.skip = 20
              set.take = 10
            } else {
              set.skip = set.skip + 10
              set.take = 10
            }
          } else {
            set.skip = 20
            set.take = 10
          }

          return {
            ...set,
          }
        })
        for (let i = 0; i < element.length; i++) {
          let obj = {
            meeting_id: element[i].meetingID,
            lead_id: element[i].leadID,
            leadNumber: element[i].leadNumber,
            schedule_date: `${element[i].scheduledTime.split(" ")[0]} ${" "}
             ${moment(element[i].scheduledTime.split(" ")[1], ["HH.mm.ss"]).format("hh:mm a")}`,

            leadCampaign: Format(element[i].campaign),
            leadStatus: Format(element[i].status),
            comments: Format(element[i].subject),
            row_id: element[i].meetingID,
          }
          value.push(obj)
        }
        if (query.skip === 0 && searchdata !== '' || search === "refresh") {
          setMeetingDetail([].concat(value))
        } else {
          setMeetingDetail(meetingDetail.concat(value))
        }
      } else if (response.status == 204) {
        setMeetingDetail([].concat(value))
      }
    }).catch((err) => {
      EventEmitter.emit('error-message-getter', {
        action: 'fetch',
        module: 'meeting',
      })
    })
  }
  const filterdataapi = (filter) => {
    setinfinitScroll((set) => {
      set.more = true
      return {
        ...set,
      }
    })
    let query = {
      userID: user_id,
      fromDate: filter.from,
      toDate: filter.to,
      module: filter.module,
      status: filter.status

    }
    setfilterdata(filter)
    query.skip = 0
    query.take = 20

    dispatch(fetch_meetings(query)).then(function (response) {

      if (response.status == 200) {
        setSearch('')
        setcount(response.data.totalCount)
        let element = response.data.data
        let value = []
        setskipdata((set) => {
          set.skip = 20
          set.take = 10
          return {
            ...set,
          }
        })
        for (let i = 0; i < element.length; i++) {
          let obj = {
            meeting_id: element[i].meetingID,
            lead_id: element[i].leadID,
            leadNumber: element[i].leadNumber,
            schedule_date: element[i].scheduledTime,
            leadCampaign: Format(element[i].campaign),
            leadStatus: Format(element[i].status),
            comments: Format(element[i].subject),
            row_id: element[i].meetingID,
          }
          value.push(obj)
        }
        setMeetingDetail([].concat(value))
      } else {
        setMeetingDetail([])
      }
    }).catch((err) => {
      EventEmitter.emit('error-message-getter', {
        action: 'fetch',
        module: 'meeting',
      })
    })
  }
  let fetchMoreData = () => {
    if (meetingDetail.length >= count) {
      setinfinitScroll((set) => {
        set.more = false
        return {
          ...set,
        }
      })
    } else {
      setTimeout(() => {
        if (searchdata !== '') {
          fetchMeetings(searchdata)
        }
        if (Object.keys(filterdata).length > 0) {
          fetchMeetings('filter')
        } else {
          fetchMeetings('mount')
        }
      }, 1000)
    }
  }

  function searchMeetings(e) {
    setSearch(e)
    setinfinitScroll((set) => {
      set.more = true
      return {
        ...set,
      }
    })
    let query = {}
    query.skip = 0
    query.take = 20
    query.filter = e
    query.userID = user_id

    dispatch(fetch_meetings(query)).then(function (response) {
      let element = response.data.data
      let value = []

      if (response.status == 200) {
        setfilterdata({})
        setcount(response.data.totalCount)
        setskipdata((set) => {
          set.skip = 20
          set.take = 10
          return {
            ...set,
          }
        })
        for (let i = 0; i < element.length; i++) {
          let obj = {
            meeting_id: element[i].meetingID,
            lead_id: element[i].leadID,
            leadNumber: element[i].leadNumber,
            schedule_date: element[i].scheduledTime,
            leadCampaign: Format(element[i].campaign),
            leadStatus: Format(element[i].status),
            comments: Format(element[i].subject),
            row_id: element[i].meetingID,
          }
          value.push(obj)
        }
        setMeetingDetail([].concat(value))
      } else if (response.status == 204) {
        setMeetingDetail([].concat(value))
      }
    }).catch((err) => {
      EventEmitter.emit('error-message-getter', {
        action: 'fetch',
        module: 'meeting',
      })
    })
  }

  const refresh = () => {

    fetchMeetings('refresh')
  }

  function clickcall(data) {

    let readystate = localStorage.getItem("selectedPause")
    if (readystate == "available") {
      let payload = {
        state: stateValue.background.websocketconnection,
        value: data.original.leadNumber.toString()
      }
      dispatch(callmodule({
        id: data.original.meeting_id.toString(),
        module: "meeting",
        phone_no: data.original.leadNumber.toString()
      }))
      dispatch(Outbound(payload.state, payload.value, { meeting: true, meetingid: data.original.meeting_id.toString() }))

    } else {

      EventEmitter.emit('error-message-getter', {
        action: 'ready',
        module: "Agent Not ready",
      })
    }


  }
  const meetingdialogopen = (data) => {
    setpopupdata((set) => {
      set.open = data
      return {
        ...set,
      }
    })
  }
  return (
    <div className="page-main-container">
      <Dialogbox
        fields={close_meetingpopup}
        value={popupdata}
        defaultclass={'dialog-body-default'}
      />
      <Dialogbox
        fields={closepopup_}
        value={popUpData_}
        className="dialog-body-default1"
        // cancel={{ display: 'none' }}
        save={'disabled'}
      />
      <Dialogbox
        fields={closepopup}
        value={popUpData}
        className="dialog-body-default1"
        shedulealart={shedulealart}
      />
      <Dialogbox
        fields={closeCreatePopup}
        value={popUpDatatoCreate}
        className="dialog-body-default1"
      />
      <Dialogbox
        fields={closeNotify}
        value={popUpData1}
        className="dialog-body-default1"
      />
      <div className="scroll-lft" md={8}>
        <div className="lead-header">
          <div className="lead-header1">
            <div className="route-header lead-header1-lft"> Meetings</div>
            {AppPermission.meeting_search && <div className="lead-search">
              <span className="material-icons lead-search-icon">search</span>
              <Form.Control
                type="text"
                placeholder="Search"
                style={{
                  border: '1px solid #e9ecef',
                  backgroundColor: '#fff',
                  padding: 10,
                  'padding-left': '40px',
                }}
                value={searchdata}
                onChange={(e) => searchMeetings(e.target.value)}
              />
            </div>}
          </div>
          <div className="lead-header2">
          {AppPermission.create_meeting && <div
              onClick={() => {
                meetingdialogopen(true)
              }}
              className=" lead-save-icon lead-create-head-rht material-icons"
            >
              add_circle
            </div>}
            {AppPermission.meeting_refresh && <div
              onClick={refresh}
              className=" lead-save-icon lead-create-head-rht material-icons"
            >
              refresh
            </div>}
            {AppPermission.meeting_filter && <Filters filterdataapi={filterdataapi} type={'meeting'} />}

          </div>
        </div>
        <div className="lead-body">
          <div
            id="meetingsDiv"
            style={{
              height: '100%',
              overflow: 'auto',
              color: 'grey',
              textAlign: 'center',
              width: '100%',
            }}
          >
            <InfiniteScroll
              dataLength={meetingDetail.length}
              next={fetchMoreData}
              hasMore={infinitScroll.more}
              scrollableTarget="meetingsDiv"
              style={{
                overflow: "initial"
              }}
            >
              <MeetingTable
                header={header}
                leaddetail={meetingDetail}
                type="meet"
                maskphoneindex={maskphoneindex}
              />
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Meeting
